














































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import BtnCheck from "@/components/scope/btn-check.vue";
import dayjs from "dayjs";
import { priceRulesEl, partsQuantityRules, priceRules } from "@/utils/verify";
const staff = namespace("staff");
const customer = namespace("customer");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const inventory = namespace("inventory");
const setting = namespace("setting");

@Component({
  components: { BtnCheck }
})
export default class ServiceEdit extends Vue {
  @setting.State serviceMode;
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @customer.Action getCustomerList;
  @parts.Action getPartsList;
  @parts.Action getPartsDetail;
  @inventory.Action getInventoryListByParts;
  @inventory.Action getOutWarehouseDetail;
  @inventory.Action outWarehouseComplete;
  @user.State userData;
  @base.Action getDictionaryList;
  @inventory.Action saveOutWarehouse;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  dayjs = dayjs;
  splitThousands = splitThousands;
  get breadData() {
    return [
      { name: this.$t("warehouse.outbound-manage"), path: "/inventory/out-warehouse" },
      { name: this.isAdd ? this.$t("warehouse.add-outbound-order") : this.$t("warehouse.edit-outbound-order") }
    ];
  }
  get isAdd() {
    return this.$route.name === "outWarehouseAdd";
  }
  orderFormDataRules = {
    outboundType: [{ required: true, message: "请选择出库类型", trigger: "change" }]
  };
  warehousePartsMap: any = {};
  handleQtyCheck(row, prop) {
    let seletedWarehouse = row.list.find(item => row.warehouseCode === item.warehouseCode);
    if (seletedWarehouse) {
      // 如果有选择的仓库，才判断
      if (row.qty > seletedWarehouse.qty) {
        if (prop === "qty") {
          row.showQtyTips = true;
        } else {
          row.showWarehouseTips = true;
        }
        setTimeout(() => {
          row.showQtyTips = false;
          row.showWarehouseTips = false;
        }, 3000);
      } else {
        row.showQtyTips = false;
        row.showWarehouseTips = false;
      }
    }
    if (prop === "warehouse") {
      let tempArr = [];
      this.orderFormData.detailList.forEach(item => {
        if (item.partsCode === row.partsCode) {
          item.warehouseCode && tempArr.push(item.warehouseCode);
        }
      });
      this.warehousePartsMap[row.partsCode] = tempArr;
    }
  }
  quitNext: any;
  get isStandardModeSaleType() {
    return !this.isAdd && this.serviceMode === "1" && this.orderFormData.outboundType === "2";
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  advisorList: any[] = [{}];
  emptyToLine = emptyToLine;
  orderFormData: any = {
    outboundType: "",
    outboundUser: "",
    remark: "",
    detailList: [],
    costAmount: "0"
  };
  get isEditUnitPrice() {
    return true;
  }
  definitionPartsData: any = {
    partsInfo: {},
    amount: "",
    qty: "",
    totalInventory: 0,
    costPrice: "",
    partsCode: "",
    warehouseCode: "",
    remark: "",
    list: []
  };

  serviceItemList: any[] = [];

  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }

  created() {
    this.setPBPX(52);
    this.init();
    this.handleAddParts(); // 默认添加第一行
  }
  outWarehouseTypeList: any = [];
  async init() {
    this.getDictionaryList("outbound_type").then(data => {
      this.outWarehouseTypeList = data.filter(item => !this.isAdd || (this.isAdd && item.dataValue !== "2"));
    });
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      this.getOutWarehouseDetail({
        outboundNo: this.orderId
      }).then(data => {
        this.orderFormData = data.data;
        data.data.detailList.forEach(item => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push({
              partsCode: item.partsCode,
              partsName: item.partsName
            });
          }
        });
        data.data.detailList.forEach((item, index) => {
          item.amount = item.costAmount;
          this.handleChooseParts(item.partsCode, index, item);
        });
        if (!this.isStandardModeSaleType) {
          this.getPartsLists("");
        }
      });
    } else {
      this.getPartsLists("");
      this.orderFormData.outboundUser = this.userData.userCode;
    }
  }

  // 确认退出
  confirmQuit() {
    this.quitNext();
  }
  getPartsLists(name = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name
    }).then(data => {
      this.partsList = data.data.list ? data.data.list : [];
    });
  }
  computedAmount(index) {
    let amount = (this.orderFormData.detailList[index].qty || 0) * this.orderFormData.detailList[index].costPrice;
    this.orderFormData.detailList[index].amount = amount.toFixed(2);
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const partsTotal = this.orderFormData.detailList.reduce((preV, curV) => preV + Number(curV.amount), 0);
    console.log(partsTotal);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error("请输入数值格式的数量或者金额");
    }
    console.log(partsTotal);
    this.orderFormData.costAmount = partsTotal.toFixed(2);
  }
  searchParts(val) {
    this.getPartsLists(val);
  }

  emitComplete(orderId?) {
    let outboundNo = orderId || this.orderId;
    this.outWarehouseComplete({
      outboundNo: outboundNo
    })
      .then(data => {
        this.$message.success("出库成功");
        this.$router.push(`/inventory/out-warehouse-view/${outboundNo}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleChooseParts(val, index, originData?) {
    if (!this.warehousePartsMap[val]) {
      this.warehousePartsMap[val] = [];
    }
    let definitionPartsData = originData ? originData : this.definitionPartsData;
    this.getInventoryListByParts({
      partsCode: val
    }).then(data => {
      data.data.list = data.data.list || [];
      let partsData = Object.assign(
        {},
        definitionPartsData,
        {
          partsCode: val,
          partsInfo: data.data.list[0] ? data.data.list[0] : {},
          list: data.data.list ? data.data.list : [],
          totalInventory: data.data.inventoryQty,
          costPrice: data.data.list[0] ? data.data.list[0].costPrice : ""
        },
        { showQtyTips: false, showWarehouseTips: false }
      );
      this.orderFormData.detailList.splice(index, 1, partsData);
      // list:[] 编辑的时候不验证库存
      this.handleQtyCheck({ list: [], partsCode: partsData.partsCode }, "warehouse");
      this.computedAmount(index);
    });
  }

  checkAddData(): boolean {
    if (!this.orderFormData.outboundType) {
      this.$message.error("请选择出库类型");
      return false;
    }
    if (this.orderFormData.detailList.length < 1) {
      this.$message.error("至少添加一项零配件");
      return false;
    }
    for (let index = 0; index < this.orderFormData.detailList.length; index++) {
      const element = this.orderFormData.detailList[index];
      if (!element.partsCode) {
        this.$message.error("请选择出库零配件");
        return false;
      }
      if (!element.qty) {
        this.$message.error("请填写出库数量");
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.qty);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (this.operationName === "complete" && !element.warehouseCode) {
        this.$message.error("请选择出库仓");
        return false;
      }
    }
    return true;
  }
  operationName: string = "";
  handleComplete() {
    this.operationName = "complete";
    this.emitSaveOutWarehouse();
  }
  handleSaveOutWarehouse() {
    this.operationName = "save";
    this.emitSaveOutWarehouse();
  }
  emitSaveOutWarehouse() {
    (this.$refs["outWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.btnStartLoading();
        this.saveOutWarehouse(this.orderFormData)
          .then(data => {
            if (this.operationName === "save") {
              this.$message.success(this.$t("base.save-success") as string);
              this.$router.push(`/inventory/out-warehouse-view/${data.data.outboundNo}`);
            } else {
              this.emitComplete(data.data.outboundNo);
            }
          })
          .finally(() => {
            this.btnStopLoading();
          });
      } else {
        console.log("error submit!!");
      }
    });
  }
  handleAddParts() {
    this.orderFormData.detailList.push(Object.assign({}, this.definitionPartsData));
  }
  deleteItem(key, index) {
    console.log(key, index);
    this.orderFormData[key].splice(index, 1);
  }
  customerList: any[] = [];
  watchOrderNum = 0;
  @Watch("orderFormData", { deep: true })
  WatchOrderData(val) {
    this.watchOrderNum += 1;
  }
}
